<template>
  <div class="libox">
    <a :href="'/Detail?contentId='+list.CONTENT_ID" target="_blank" class="phoneShow" />
    <a class="topColumnname" :href="'/column/?columnId='+list.COLUMN_ID" target="_blank">
      {{ list.COLUMN_NAME }}
    </a>
    <div class="topimgSize">
      {{ list.CONTENT_PHOTO_SIZE }}图
    </div>
    <a class="imgbox" :href="'/Detail?contentId='+list.CONTENT_ID" target="_blank">
      <img v-if="list.CONTENT_PHOTO_SMALL" :src="list.CONTENT_PHOTO_SMALL" alt="">
      <img v-else :src="defaultimg[randomimg]" alt="">
      <div class="shadow" />
    </a>
    <p>
      <span class="titlename">{{ list.CONTENT_TITLE }}</span>
      <span class="hot_time">{{ list.CONTENT_ISSUE_DATE|changeTime }}</span>
      <span class="el-icon-view viewNumber">  {{ list.CONTENT_READING_SIZE|changenum }}</span>
      <span class="el-icon-star-on viewNumber viewStar">  {{ list.CONTENT_COLLECTION_SIZE|changenum }}</span>
    </p>
  </div>
</template>

<script>
// ///首页列表模板上中下形式
export default {
  name: 'ListTemolate3',
  props: ['list'],
  data() {
    return {
      randomimg: Math.floor(Math.random() * 5),
      defaultimg: [
        require('@/static/newsdefault1.jpg'),
        require('@/static/newsdefault2.jpg'),
        require('@/static/newsdefault3.jpg'),
        require('@/static/newsdefault4.jpg'),
        require('@/static/newsdefault5.jpg')
      ]
    }
  },
  methods: {
    goColumn: function(contentId, name) {
      window.location.href = '/column/?columnId=' + contentId
    },
    goDetail: function(contentId) {
      const { href } = this.$router.resolve({
        path: '/Detail',
        name: 'dt',
        query: {
          contentId
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .phoneShow{
    display: none;
  }
    .libox{
        display: inline-block;
        width: 100%;
        font-size: 0;
        transition: 0.3s;
        position: relative;
        .topimgSize{
            text-align: center;
            position: absolute;
            top:10px;
            left: 220px;
            width: 35px;
            background-color:rgba(51,51,51,.5);
            font-size: 12px;
            color: #ffffff;
            height: 18px;
            line-height: 18px;
            border-radius: 8px;
            z-index: 6;
            &:hover{
                background-color: rgba(237,64,64,.5);
            }
        }
        .topColumnname{
          text-align: center;
            position: absolute;
            top:10px;
            left: 10px;
          padding: 0 5px;
            background-color:rgba(51,51,51,.5);
            font-size: 12px;
            color: #ffffff;
            height: 18px;
            line-height: 18px;
            border-radius: 3px;
            cursor: pointer;
           z-index: 6;
            &:hover{
                background-color: rgba(237,64,64,.5);
            }
        }
      .imgbox{
        width: 267px;
        height: 280px;
        overflow: hidden;
        position: relative;
        display: inline-block;
        img{
          height: 100%;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .shadow{
          width: 267px;
          height: 280px;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 3;
          cursor: pointer;
          background-color:rgba(0,0,0,.3);
          &:hover{
            background-color:rgba(0,0,0,0);
          }
        }
      }
        p{
            position: absolute;
            top: 180px;
            width: 247px;
            height: 93px;
            /*border-left: 1px solid #f0f0f0;*/
            /*border-right: 1px solid #f0f0f0;*/
            /*border-bottom: 1px solid #f0f0f0;*/
            /*-moz-box-shadow:1px 1px 3px #f3f3f3;*/
            /*-webkit-box-shadow:1px 1px 3px #f3f3f3;*/
            /*box-shadow:1px 1px 3px #f3f3f3;*/
            text-align: left;
            padding: 0 10px;
            z-index: 5;
            .titlename{
                cursor: pointer;
                color: #ffffff;
                font-size: 14px;
                font-weight:500;
                display: inline-block;
                height:55px;
                line-height: 25px;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            .hot_time{
                display: inline-block;
                width: 147px;
                height: 20px;
                margin-top: 5px;
                font-size: 12px;
                /*color: #b2b2b2;*/
                color: #ffffff;
            }
            .viewNumber{
                display: inline-block;
                height: 20px;
                width: 50px;
                margin-top: 10px;
                font-size: 12px;
                /*color: #b2b2b2;*/
                color: #ffffff;
              text-align: right;
            }
            .viewStar{
                width: 50px;
            }
        }
    }

</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .phoneShow{
      display: block;
      width: 100%;
      height: 280px;
      background-color: transparent;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9;
    }
    .libox{
      .topimgSize{
        left: 290px;
      }
      p{
        width: 90%;
        margin-left: 0;
      }
      .imgbox{
        width: 100%;
        .shadow{
          width: 100%;
        }
      }
    }
  }
</style>
